import { Group, Text } from '@mantine/core'
import { useNavigate } from '@tanstack/react-router'
import { TbExternalLink } from 'react-icons/tb'

const TableLink = ({
  children,
  href,
  internal = false,
}: {
  children: React.ReactNode
  href: string
  internal?: boolean
}) => {
  const navigate = useNavigate()

  return (
    <Group
      gap="xs"
      onClick={() => {
        if (internal) {
          navigate({ to: href })
        } else {
          window.open(href, '_blank')
        }
      }}
    >
      <Text
        component="a"
        href={href}
        style={{
          color: 'var(--mantine-color-blue-6)',
          textDecoration: 'none',
        }}
      >
        {children}
        <TbExternalLink size={14} style={{ marginLeft: 8 }} />
      </Text>
    </Group>
  )
}

export default TableLink
